// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"11":"38b8bab4","98":"03444b95","305":"2d7d5a89","886":"65740873"}[chunkId] + ".chunk.js";
};